import React, { useEffect, useState } from 'react'
import BlogCard from './BlogCard'
import { get } from '../helpers/Api'
import { Skeleton } from '@nextui-org/react'

const BlogView = () => {
    const [news, setNews] = useState([])
    const [isLoading, setLoading] = useState(true)

    const getNews = () => {
        get(`news?limit=40`, 'news-api')
            .then((response) => setNews(response))
            .catch((error) => console.error(error))
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            getNews()
            setLoading(false)
        }
    }, [])

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 sm:gap-4 mx-auto">
            {!isLoading
                ? news?.map((blogItem, index) => (
                      <BlogCard
                          key={index}
                          id={blogItem?.id}
                          feedImage={blogItem?.feedImage}
                          storyImage={blogItem?.storyImage}
                          title={blogItem?.storyTitle}
                          summary={blogItem?.summary}
                          timestamp={blogItem?.timestamp}
                          category={blogItem?.category}
                          author={blogItem?.author}
                      />
                  ))
                : Array.from(new Array(12)).map(() => (
                      <div className="space-y-4 p-4">
                          <Skeleton className="w-full h-[200px] rounded-lg">
                              <div className="h-24 rounded-lg bg-default-300"></div>
                          </Skeleton>
                          <Skeleton className="w-full h-[54px] rounded-lg">
                              <div className="h-24 rounded-lg bg-default-300"></div>
                          </Skeleton>
                          <Skeleton className="w-full h-[60px] rounded-lg">
                              <div className="h-24 rounded-lg bg-default-300"></div>
                          </Skeleton>
                          <Skeleton className="w-1/2 h-[24px] rounded-lg">
                              <div className="h-24 rounded-lg bg-default-300"></div>
                          </Skeleton>
                      </div>
                  ))}
        </div>
    )
}
export default BlogView
